import { Label } from "design-system/atoms/Label"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "design-system/molecules/Select"
import { cn } from "design-system/utils"
import { usePredefinedSegmentGroupsTranslation } from "modules/segments/hooks/usePredefinedSegmentGroupsTranslation"
import { useSegmentGroupsQuery } from "modules/segments/hooks/useSegmentGroupsQuery"
import { useTranslation } from "react-i18next"

type Props = {
  segmentGroupId: string
  selectedSegmentGroupId: string
  onValueChange: (value: string) => void
  noneValue: string
  disabled: boolean
}

export function SegmentGroupCompareSelect({
  segmentGroupId,
  selectedSegmentGroupId,
  onValueChange,
  noneValue: NONE_VALUE,
  disabled,
}: Props) {
  const { t } = useTranslation()
  const { data: segmentGroups = [] } = useSegmentGroupsQuery()
  const { getSegmentGroupTranslation } = usePredefinedSegmentGroupsTranslation()

  const content = (
    <div className="flex flex-col gap-1 items-start">
      <Label>{t("segments.distribution.select.label")}</Label>
      <Select value={selectedSegmentGroupId} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger
          className={cn("w-fit", selectedSegmentGroupId === NONE_VALUE && "text-muted-foreground")}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE_VALUE} className="text-muted-foreground">
            {t("segments.distribution.select.none")}
          </SelectItem>
          {segmentGroups
            .filter((sg) => sg.id !== segmentGroupId)
            .map((segmentGroup) => (
              <SelectItem key={segmentGroup.id} value={segmentGroup.id}>
                {getSegmentGroupTranslation(segmentGroup)}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </div>
  )

  if (disabled) {
    return (
      <Tooltip>
        <TooltipTrigger>{content}</TooltipTrigger>
        <TooltipContent>{t("segments.distribution.select.disabledTooltip")}</TooltipContent>
      </Tooltip>
    )
  }

  return content
}
